var _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgZiplocBags = function SvgZiplocBags(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 600 600",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ICONS"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "211.17 572.28 211.17 572.28 151.69 437.57 211.17 572.28",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "545.94 423.38 547.14 422.84 399.42 88.27 64.87 237.07 545.94 423.38",
    fill: "#6ab4e5"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "547.67 424.05 545.94 423.38 64.87 237.07 63.44 237.7 151.69 437.57 211.17 572.28 211.7 573.48 547.67 424.05",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.69 61.7 375.96 35.14 379.6 43.38 43.63 192.81 39.99 184.57 49.54 206.21 385.52 56.78 387.69 61.7",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.87,237.07,399.42,88.27h0L387.69,61.7l-336,149.44L63.44,237.7h0Zm-9.75-18.23,336-149.44,2.17,4.93-336,149.43Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.52 56.78 49.54 206.21 49.54 206.21 51.72 211.14 387.69 61.7 385.52 56.78",
    fill: "#f0592b"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.6 43.38 375.96 35.14 39.99 184.57 43.63 192.81 379.6 43.38",
    fill: "#16a99e"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.09 69.4 55.12 218.84 57.29 223.76 393.26 74.33 391.09 69.4",
    fill: "#f0592b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.07,156.37c2.87,0,26.5.88,26.5,28.71a2.92,2.92,0,0,0,2.87,2.87,2.54,2.54,0,0,0,2.65-2.65c0-27.83,23.85-28.71,26.5-28.71h.22a3,3,0,0,0,2.87-3.09,2.92,2.92,0,0,0-2.87-2.87c-2.65,0-26.5-.88-26.5-28.71a2.87,2.87,0,0,0-5.74,0c0,27.83-23.85,28.71-26.5,28.71h-.22a2.87,2.87,0,0,0-2.65,2.87A2.92,2.92,0,0,0,478.07,156.37Z",
    fill: "#fff"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgZiplocBags, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ziploc_bags.5223afe9.svg";
export { ForwardRef as ReactComponent };